import React, { useState, useRef, useEffect } from "react";
import { icons } from "../../constants";
import { useNavigate } from "react-router-dom";
import "./styles/styles.css";
import "../../styles/global.css";
import { formatDate } from "../../utils/formatDate";
import AccreditationButton from "../AccreditationButton/AccreditationButton";
import AccreditationInput from "../AccreditationInput/AccreditationInput";
import IconWithTooltip from "../IconWithTooltip/IconWithTooltip";

const TIER = process.env.REACT_APP_MODE;

const EventTitle = ({
  event,
  t,
  className,
  handleEditEvent,
  theme,
  edit,
  id,
}) => {
  const navigate = useNavigate();
  const isSingle = localStorage.getItem("single") === "true";
  const [isCopied, setIsCopied] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const shareRef = useRef(null);

  useEffect(() => {
    if (!isShareOpen) return;
    const onDocClick = (e) => {
      if (shareRef.current && !shareRef.current.contains(e.target)) {
        setIsShareOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [isShareOpen]);

  console.log("event", event);

  // utils/copyToClipboard.js
  async function copyToClipboard(text) {
    if (typeof window === "undefined") {
      return Promise.reject(new Error("No window"));
    }

    const canUseModern =
      typeof navigator !== "undefined" &&
      navigator.clipboard &&
      window.isSecureContext;

    if (canUseModern) {
      return navigator.clipboard.writeText(text);
    }

    // fallback for http / insecure contexts
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    ta.setAttribute("readonly", "");
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    } finally {
      document.body.removeChild(ta);
    }
  }

  return (
    <div
      className={`flex-direction-row gap-18 justify-between width-100 event-title ${
        isSingle ? "single" : ""
      } ${className ? className : ""}`}
    >
      <div className="flex-direction-row gap-18 items-center width-100">
        {/* {!isSingle && (
          <div
            className="flex-direction-row items-center pointer events-title-back"
            onClick={() => navigate(-1)}
          >
            <img src={icons.arrow_left} alt="back" />
          </div>
        )} */}
        {!event ? (
          <div
            className="animated-bg animated-div-title"
            style={{ borderRadius: "12px" }}
          >
            {" "}
          </div>
        ) : (
          <div className="flex-direction-row gap-8 items-center width-100">
            <h2
              className="font-36 inria-sans-300"
              style={{ color: "var(--Neutral-dark)", flexShrink: 0 }}
            >
              {event.naziv}
            </h2>
            {/* First's login represents one specific group's registration
                coordinator (dogadjajGrupaKorisnikId) — event.dogadjajGrupa
                is *their* group for this event, not a general concept, so
                this is meaningless (and absent from the query) on Second/Third. */}
            {TIER === "first" && event?.dogadjajGrupa?.naziv && (
              <span className="event-title-group-badge inria-sans-700 font-14">
                {t("EVENT_GROUP")}: {event.dogadjajGrupa.naziv}
              </span>
            )}
          </div>
        )}
      </div>
      <div className="flex-direction-row items-center justify-end gap-18 width-100 events-title-back-date">
        <div className="flex-direction-column items-end gap-2 events-title-location-date">
          <h5
            className="font-24 inria-sans-700"
            style={{
              color: "var(--Neutral-dark)",
              flexShrink: 0,
              textAlign: "right",
            }}
          >
            {event?.lokacija}
          </h5>
          <div className="flex-direction-row items-center gap-12 event-title-date-row">
            {edit && (
              <IconWithTooltip tooltip={t("EDIT")}>
                <img
                  src={theme == "light" ? icons.pen : icons.pen_dark}
                  width={20}
                  height={20}
                  className="pointer event-title-edit"
                  onClick={handleEditEvent}
                  alt="edit"
                />
              </IconWithTooltip>
            )}
            {id && (
              <div className="relative event-share-wrapper" ref={shareRef}>
                {/* event.link is only populated for xsall/xsmain/xspress (see
                    gs.be dogadjaji.js) — an xspress user's own press
                    registration link for this event. Everyone else shares
                    the plain login link, which redirects to this event once
                    they authenticate (see LoginSinglePage.jsx). */}
                <IconWithTooltip
                  tooltip={
                    event?.link
                      ? t("SHARE_PRESS_LINK") || "Podeli press link"
                      : t("SHARE_LOGIN_LINK") || "Podeli link"
                  }
                >
                  <img
                    src={theme === "light" ? icons.link : icons.link_dark}
                    width={20}
                    height={20}
                    className="pointer event-title-share"
                    onClick={() => setIsShareOpen((prev) => !prev)}
                    alt="share"
                  />
                </IconWithTooltip>
                {isShareOpen && (
                  <div className="event-share-popover">
                    <AccreditationInput
                      className={`event-firs-link-input event-firs-link-input-full ${
                        isCopied ? "copy-animation" : ""
                      }`}
                      value={
                        event?.link
                          ? `${window.location.origin}/press/${event.link}`
                          : `${window.location.origin}/login/${id}`
                      }
                    />
                    <AccreditationButton
                      title={t("COPY")}
                      type="save"
                      className={`event-firs-link-btn ${isCopied ? "copy-animation" : ""}`}
                      onClick={async () => {
                        try {
                          await copyToClipboard(
                            event?.link
                              ? `${window.location.origin}/press/${event.link}`
                              : `${window.location.origin}/login/${id}`,
                          );
                          setIsCopied(true);
                          setTimeout(() => setIsCopied(false), 600);
                        } catch {
                          // optional: toast error
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            )}
            {event ? (
              <p className="font-14 inria-sans-400 event-title-date">
                {" "}
                {formatDate(event?.trajanje_od)}
              </p>
            ) : (
              <div className="flex-direction-column gap-8">
                <div
                  className="animated-bg animated-div-title"
                  style={{ borderRadius: "12px" }}
                >
                  {" "}
                </div>
                <div className="flex-direction-row">
                  <div
                    className="animated-bg animated-div"
                    style={{ borderRadius: "12px" }}
                  >
                    {" "}
                  </div>
                  -
                  <div
                    className="animated-bg animated-div"
                    style={{ borderRadius: "12px" }}
                  >
                    {" "}
                  </div>
                </div>
              </div>
            )}

            <p className="font-14 inria-sans-400 event-title-date">-</p>
            <p className="font-14 inria-sans-400 event-title-date">
              {formatDate(event?.trajanje_do)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventTitle;
